/* Aura Mode: looks en maattabellen. Elke look bestaat uit stukken; de flatlays worden uit deze gegevens getekend. */
window.AuraData = {
 looks: [
 {id:'clubhuis',no:'01',name:'Het Clubhuis',g:'h',occ:['weekend','diner'],wall:'#D9D1C4',
  desc:'Een crème kabeltrui met de kraag van een lichtblauw oxford erboven. Een navy chino en tabak suède loafers maken het af.',
  pieces:[
   {r:'top',k:'knit',neck:'crew',cable:1,n:'Kabeltrui van lamswol',c:'Crème',h:'#E9E1CE',p:159,s:'top'},
   {r:'under',k:'shirt',n:'Oxford overhemd',c:'Lichtblauw',h:'#BACCDF',p:79,s:'top'},
   {r:'bottom',k:'chino',pleat:1,n:'Chino met plooi',c:'Navy',h:'#262E45',p:119,s:'bottom'},
   {r:'belt',n:'Leren riem',c:'Cognac',h:'#7A4A2A',p:59,s:'one'},
   {r:'shoes',k:'loafer',n:'Suède loafers',c:'Tabak',h:'#7B5538',sole:'#3B2A1E',p:169,s:'shoe'},
   {r:'acc',k:'sunglasses',n:'Zonnebril',c:'Schildpad',h:'#5A3720',p:89,s:'one'}]},
 {id:'racquet',no:'02',name:'Racquet Club',g:'h',occ:['club','weekend'],wall:'#D6CEC0',
  desc:'Een rugby polo in flessengroen met een geborduurde crème band. Lichte jeans en witte tennisschoenen houden het ontspannen.',
  pieces:[
   {r:'top',k:'knit',neck:'polo',band:'#EEE7D6',bandText:'Racquet Club',bandInk:'#24402F',collar:'#EEE7D6',n:'Rugby polo',c:'Flessengroen',h:'#2A4535',p:119,s:'top'},
   {r:'bottom',k:'denim',n:'Rechte jeans',c:'Lichtblauw',h:'#7D93AE',p:119,s:'bottom'},
   {r:'shoes',k:'sneaker',tab:'#2A4535',n:'Leren tennisschoenen',c:'Wit en groen',h:'#F4F1EA',p:139,s:'shoe'},
   {r:'acc',k:'cap',logo:'#2A4535',n:'Katoenen pet',c:'Crème',h:'#E8E0CC',p:45,s:'one'}]},
 {id:'wassenaar',no:'03',name:'Zondag in Wassenaar',g:'h',occ:['weekend','werk'],wall:'#DAD3C8',
  desc:'Een navy schipperstrui over een wit oxford. Zandkleurige chino, donkerbruine penny loafers en een horloge met leren band.',
  pieces:[
   {r:'top',k:'knit',neck:'zip',n:'Schipperstrui met rits',c:'Navy',h:'#1F2740',p:149,s:'top'},
   {r:'under',k:'shirt',n:'Oxford overhemd',c:'Wit',h:'#F3F1EC',p:79,s:'top'},
   {r:'bottom',k:'chino',n:'Chino',c:'Zand',h:'#CFC2A3',p:109,s:'bottom'},
   {r:'belt',n:'Leren riem',c:'Donkerbruin',h:'#3E2A1E',p:59,s:'one'},
   {r:'shoes',k:'loafer',n:'Penny loafers',c:'Donkerbruin',h:'#3E2A1E',sole:'#221813',p:179,s:'shoe'},
   {r:'acc',k:'watch',n:'Horloge met leren band',c:'Goud en bruin',h:'#5B3A24',p:149,s:'one'}]},
 {id:'gracht',no:'04',name:'Kantoor aan de gracht',g:'h',occ:['werk','diner'],wall:'#D3CDC4',
  desc:'Een navy double breasted blazer met gouden knopen. Wit overhemd, grijze flanel en oxblood loafers. Het pochet in bordeaux is het enige accent.',
  pieces:[
   {r:'top',k:'blazer',n:'Double breasted blazer',c:'Navy',h:'#1F2638',p:289,s:'top'},
   {r:'under',k:'shirt',n:'Overhemd van poplin',c:'Wit',h:'#F5F4F0',p:89,s:'top'},
   {r:'bottom',k:'chino',pleat:1,n:'Flanellen pantalon',c:'Grijs',h:'#8C8B88',p:139,s:'bottom'},
   {r:'shoes',k:'loafer',n:'Leren loafers',c:'Oxblood',h:'#4B1C1F',sole:'#211514',p:189,s:'shoe'},
   {r:'acc',k:'square',n:'Pochet van zijde',c:'Bordeaux',h:'#7A2430',p:35,s:'one'}]},
 ],
 sizes: {top:['XS','S','M','L','XL'],bottom:{h:['28','30','32','34','36']},shoe:{h:['40','41','42','43','44','45']}}
};
